import { render, staticRenderFns } from "./WhatShipment.vue?vue&type=template&id=6dc02d76&scoped=true"
import script from "./WhatShipment.vue?vue&type=script&lang=ts"
export * from "./WhatShipment.vue?vue&type=script&lang=ts"
import style0 from "./WhatShipment.vue?vue&type=style&index=0&id=6dc02d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc02d76",
  null
  
)

export default component.exports